<template>
  <div class="right-nav">
    <div class="right-item">
      <img class="right-icon" src="../../../assets/images/icon_phone.png" alt="">
      <div>联系电话：400-061-6167</div>
    </div>
    <a class="right-item" onclick="window.open('http://chat32.live800.com/live800/chatClient/chatbox.jsp?companyID=138747&jid=9767903609&configID=23526&enterurl=http://chat32.live800.com:8080/live800/preview.jsp','','height=500,width=650,directories=no,status=no,menubar=no,scrollbars=no')">
      <img class="right-icon" src="../../../assets/images/icon_connect.png" alt="">
      <div>在线咨询</div>
    </a>
    <!-- <div class="right-item" @click="goFenxiao">
      <img class="right-icon" src="../../../assets/images/icon_school.png" alt="">
      <div>全国分校</div>
    </div> -->
    <div :class="topFlag ? 'showTop' : 'hideTop'" class="right-item back-top" @click="backtop">
      <img class="right-icon" src="../../../assets/images/icon_top.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      topFlag: false
    }
  },
  mounted(){
    window.addEventListener("scroll",this.showbtn,true);
  },
  methods: {
    showbtn(){
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop
      if (that.scrollTop > document.documentElement.clientHeight) {
          that.topFlag = true
      } else {
          that.topFlag = false
      }
    },
    goFenxiao() {
      let url = this.$router.resolve({
        path: '/ett/fx'
      })
      window.open(url.href, '_blank')
    },
    // 回到顶部
    backtop(){
      let timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5); 
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        // this.isTop = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },30)
    },
  }
}
</script>
<style lang="scss" scoped>
.right-nav {
  position: fixed;
  right: 0;
  top: 50%;
  // transform: translateY(-50%);
  border-radius: 4px;
  z-index: 100;
  .right-item {
    position: relative;
    display: block;
    width: 56px;
    height: 56px;
    background: #2E96FF;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, .3);
    cursor: pointer;
    .right-icon {
      width: 32px;
      height: 32px;
      display: block;
      margin: 0 auto;
      margin-top: 12px;
    }
    div {
      position: absolute;
      top: 0;
      right: 58px;
      height: 56px;
      background: #FFFFFF;
      box-shadow: 0px 2px 15px 5px rgba(46, 150, 255, 0.1);
      border-radius: 4px;
      line-height: 56px;
      padding: 0 20px;
      white-space: nowrap;
      transition: opacity .25s, transform .3s;
      opacity: 0;
      transform: scale(.01);
      transform-origin: 100% 95%;
      font-size: 18px;
      font-weight: 400;
      color: #555555;
    }
  }
  .right-item:hover {
    background: rgba(46, 150, 255, .8);
    div {
      display: block;
      visibility: visible;
      opacity: 1;
      transform: scale(1);
    }
  }
  .hideTop {
    transition: opacity .5s;
    opacity: 0;
  }
  .showTop {
    transition: opacity .5s;
    opacity: 1;
  }
}
</style>